import { types } from "../types/types";
const intitalState = {
    allCallLogs: [],
    allCallRecordings: [],
};

const callLogsReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CALL_LOGS:
            return {
                ...state,
                allCallLogs: action.payload,
            };
        case types.CALL_RECORDINGS:
            return {
                ...state,
                allCallRecordings: action.payload,
            };
        default:
            return { ...state };
    }
};

export default callLogsReducer;
